import React from 'react';
import WName from '../WName';
import PL from './ProblemLink';
import AL from '../angles/AngleLink';
import QL from '../faq/QuestionLink';
import NW from '../neologisms/NewWord';
import OML from '../ormaybe/OrMaybeLink';
import LRL from '../longreads/LongReadLink';
import {E1, E2, Qual} from '../common';

// This feels like torment
export const torment = {
  name: "torment",
  prelude: <span>
    Have you NO mercy, <NW>zyzzyva</NW>?
  </span>,
  header: <span>
    This is literally TORMENT
  </span>,
  outside: <span>Or it <i>feels</i> like that.</span>,
  preview: <div className="problem-preview">
    <p>This has to do with the comfort of <i><QL name="salvation.think">not thinking</QL></i> (and <i><LRL name="communism">not sharing</LRL></i>) being the literal <PL>Opium des Volkes</PL> (<QL name="languages">opium of the people</QL>).</p>
    <p>Because <AL>you</AL> (as a single <QL name="isolation">isolated</QL> die-alone <i><QL name="pg.">mind</QL></i> under <NW>kennis-apartheid</NW>) <i>do not have the <NW>co-fo</NW> to deal with this</i>.</p>
  </div>,
  text: <div className="problem-text">
    <p>Want a ‘big <LRL>answer</LRL>’? Our <QL>salvation</QL> is <i><QL name="salvation.">actually thinking</QL></i>.</p>
    <p>So if it physically <i>hurts</i>, ask for help. <AL name="together">We rise to gether, or we all die alone</AL>.</p>
    <p>[Under construction]</p>
  </div>,
};

